import { ICreateCampaignsIn } from "../../models/input/agendaApi/ICreateCampaignsIn";
import { IDeleteCampaignsIn } from "../../models/input/agendaApi/IDeleteCampaignsIn";
import { IUpdateCampaignsIn } from "../../models/input/agendaApi/IUpdateCampaignsIn";
import { IGetVisualExecutionPhotosDto } from "../../models/dto/agendaApi/IGetVisualExecutionPhotosDto";
import { IVisualInventoryDto } from "../../models/dto/agendaApi/IVisualInventoryDto";
import * as ApiWithToken from "../callApiWithToken";

const visualExecutionService = {
    getCategories: async function (languageId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `VisualExecution/GetCategoryFilter?LanguageID=${languageId}`);
    },
    getMaterials: async function (languageId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `VisualExecution/GetMaterialsFilter?LanguageID=${languageId}`);
    },
    getSubcategories: async function (languageId: number, categoryId: number, materialId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `VisualExecution/GetSubCategoriesFilter?LanguageID=${languageId}&CategoryID=${categoryId}&MaterialID=${materialId}`);
    },
    getFurniture: async function (languageId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `VisualExecution/GetMaterialsFurnishingFilter?LanguageID=${languageId}`);
    },
    getMaterialsPOP: async function (languageId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `VisualExecution/GetMaterialsPopFilter?LanguageID=${languageId}`);
    },
    getPhotos: async function (getVisualExecution: IGetVisualExecutionPhotosDto) {
        return ApiWithToken.postApi(process.env.REACT_APP_AGENDAS_API + `VisualExecution/GetVisualExecutionPhotos`, getVisualExecution);
    },
    getStatesByCountryList: async function (countryIds: string) {
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `VisualExecution/GetStatesByCountriesList?CountryIDs=${countryIds}`);
    },
    getCitiesByStateList: async function (stateIds: string) {
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `VisualExecution/GetCitiesByStatesList?StatesIDs=${stateIds}`);
    },
    getCampaigns: async function () {
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `VisualExecution/GetCampaigns`);
    },
    createCampaigns: async function (form: ICreateCampaignsIn) {
        return ApiWithToken.postApi(process.env.REACT_APP_AGENDAS_API + `VisualExecution/CreateCampaigns`, form);
    },
    updateCampaigns: async function (form: IUpdateCampaignsIn) {
        return ApiWithToken.putApi(process.env.REACT_APP_AGENDAS_API + `VisualExecution/UpdateCampaigns`, form);
    },
    deleteCampaigns: async function (form: IDeleteCampaignsIn) {
        return ApiWithToken.putApi(process.env.REACT_APP_AGENDAS_API + `VisualExecution/DeleteCampaigns`, form);
    },
    getSubretailsByCountryList: async function (countryIds: string) {
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `VisualExecution/GetSubretailsByCountryList?CountryIDs=${countryIds}`);
    },
}

export default visualExecutionService;